
import { CareerCategory } from '@/types/assessment';

export const careerCategories: CareerCategory[] = [
  {
    id: 1,
    name: "Engineering",
    subcategories: [
      "Electrical and Electronics Engineering",
      "Mechanical and Automobile Engineering",
      "Civil Engineering",
      "Chemical and Petroleum Engineering",
      "Environmental Engineering",
      "Aerospace Engineering",
      "CS, IT and Software Engineering",
      "Biomedical and Biotechnology Engineering",
      "Mining Engineering",
      "Power Engineering",
      "Sound Engineering",
      "Marine Engineering",
      "Robotics",
      "Genetic Engineering",
      "Artificial Intelligence and Machine Learning",
      "Nanotechnology",
      "Ceramic Engineering",
      "Construction Engineering",
      "Industrial and Production Engineering",
      "Instrumentation Engineering",
      "Mechatronics",
      "Naval Architecture and Ocean Engineering",
      "Nuclear Engineering",
      "Structural Engineering",
      "Game Development"
    ]
  },
  {
    id: 2,
    name: "Medical Hacking",
    subcategories: []
  },
  {
    id: 3,
    name: "Aviation",
    subcategories: [
      "Pilot",
      "Aircraft Maintenance Engineer",
      "Air Traffic Controller",
      "Aircraft Maintenance Engineering"
    ]
  },
  {
    id: 4,
    name: "Architecture",
    subcategories: []
  },
  {
    id: 5,
    name: "Merchant Navy",
    subcategories: []
  },
  {
    id: 6,
    name: "Food & Agriculture",
    subcategories: [
      "Food Science and Technology",
      "Agricultural Biotechnology",
      "Agronomy",
      "Plant Breeding and Genetics",
      "Soil Science",
      "Dairy Technology",
      "Horticulture",
      "Agricultural Engineering"
    ]
  },
  {
    id: 7,
    name: "Physical Science",
    subcategories: [
      "Astronomy",
      "Meteorology",
      "Geology",
      "Disaster Management",
      "Forensic Science",
      "Cartography",
      "Chemistry",
      "Paper Chemistry",
      "Physics",
      "Astrophysics",
      "Fishery",
      "Wildlife Conservation",
      "Molecular Biology",
      "Virology",
      "Water Management"
    ]
  },
  {
    id: 8,
    name: "Life Science & Environment",
    subcategories: [
      "Biology",
      "Botany",
      "Zoology",
      "Microbiology",
      "Physiology",
      "Biochemistry",
      "Genetics",
      "Marine Biology",
      "Environmental Science",
      "Bioinformatics",
      "Sports Science",
      "Biophysics",
      "Epidemiology",
      "Oceanography",
      "Entomology"
    ]
  },
  {
    id: 9,
    name: "Maths & Statistics",
    subcategories: []
  },
  {
    id: 10,
    name: "Medicine",
    subcategories: [
      "Doctor",
      "Veterinarian",
      "Homeopathy",
      "Ayurveda",
      "Dentist",
      "Psychiatry",
      "Anesthesiologist",
      "Pathologist",
      "Podiatrist",
      "Speech Pathologist",
      "Sports Medicine"
    ]
  },
  {
    id: 11,
    name: "Allied Medicine",
    subcategories: [
      "Optometry",
      "Public Health Administration",
      "Occupational Therapist",
      "Radio Technician",
      "Audiologist",
      "Clinical Research",
      "Medical Laboratory",
      "Nursing",
      "Physiotherapist",
      "Pharmacy",
      "Sonography"
    ]
  },
  {
    id: 12,
    name: "Nutrition & Fitness",
    subcategories: []
  },
  {
    id: 13,
    name: "Beauty & Wellness",
    subcategories: []
  },
  {
    id: 14,
    name: "Animation & Graphics",
    subcategories: []
  },
  {
    id: 15,
    name: "Media & Communication",
    subcategories: [
      "Event Manager",
      "Wedding Planner",
      "Mass Communication",
      "Journalism",
      "Video/Radio Jockey",
      "Writer, Editor, Copywriter",
      "Public Relations",
      "Content Writer",
      "Image Consultant"
    ]
  },
  {
    id: 16,
    name: "Applied Arts",
    subcategories: []
  },
  {
    id: 17,
    name: "Performing Arts",
    subcategories: [
      "Music",
      "Choreographer",
      "Acting/Dramatics",
      "Modelling",
      "Stage Lighting"
    ]
  },
  {
    id: 18,
    name: "Cabin Crew",
    subcategories: []
  },
  {
    id: 19,
    name: "Hotel Management",
    subcategories: []
  },
  {
    id: 20,
    name: "Civil Services",
    subcategories: [
      "Railways",
      "Customs",
      "Excise",
      "Income Tax",
      "Civil Services",
      "Indian Provincial",
      "Indian Foreign Service",
      "Indian Corporate Law Service",
      "Indian Legal Service",
      "Central Labour Service",
      "Central Secretariat"
    ]
  },
  {
    id: 21,
    name: "Defense",
    subcategories: [
      "Army",
      "Navy",
      "Airforce",
      "Armed Police"
    ]
  },
  {
    id: 22,
    name: "Marketing & Advertising",
    subcategories: []
  },
  {
    id: 23,
    name: "Sales",
    subcategories: []
  },
  {
    id: 24,
    name: "Management",
    subcategories: []
  },
  {
    id: 25,
    name: "Entrepreneurship",
    subcategories: []
  },
  {
    id: 26,
    name: "Law",
    subcategories: []
  },
  {
    id: 27,
    name: "Finance & Banking",
    subcategories: [
      "Finance",
      "Stock Broking",
      "Banking",
      "Chartered Financial Analyst (CFA)"
    ]
  },
  {
    id: 28,
    name: "Commerce & Accounts",
    subcategories: [
      "Accountant",
      "Chartered Accountant (CA)",
      "Cost Accountant",
      "Company Secretary (CS)",
      "Forensic Accounting",
      "Certified Public Accountant"
    ]
  },
  {
    id: 29,
    name: "Actuarial Sciences",
    subcategories: []
  },
  {
    id: 30,
    name: "Economics",
    subcategories: []
  },
  {
    id: 31,
    name: "Social Sciences & Research",
    subcategories: [
      "Political Science",
      "Psychology",
      "Sociology",
      "Geography",
      "History",
      "Archaeology",
      "Anthropology",
      "Instructional Design",
      "Language",
      "Development Studies",
      "Gender/Women Studies",
      "Public Administration",
      "Museology",
      "Sustainability Management",
      "Palmistry",
      "Tarot Card Reading",
      "Numerology",
      "Graphology",
      "Astrology"
    ]
  },
  {
    id: 32,
    name: "Social Services",
    subcategories: []
  },
  {
    id: 33,
    name: "Education & Training",
    subcategories: [
      "Teacher",
      "Professor",
      "Counsellor",
      "Special Educator"
    ]
  },
  {
    id: 34,
    name: "Distribution & Logistics",
    subcategories: []
  },
  {
    id: 35,
    name: "Political Science",
    subcategories: []
  },
  {
    id: 36,
    name: "Culinary Arts",
    subcategories: []
  },
  {
    id: 37,
    name: "Psychology",
    subcategories: [
      "Cognitive Psychologist",
      "Clinical Psychologist",
      "Developmental Psychologist",
      "Forensic Psychologist",
      "Organizational Psychologist",
      "Quantitative Psychologist",
      "Sports Psychologist",
      "Hypnotherapy"
    ]
  },
  {
    id: 38,
    name: "Geography",
    subcategories: [
      "Cartography",
      "Surveying",
      "Climatology",
      "Meteorology"
    ]
  },
  {
    id: 39,
    name: "Language",
    subcategories: []
  },
  {
    id: 40,
    name: "Museology",
    subcategories: []
  },
  {
    id: 41,
    name: "International Relations",
    subcategories: [
      "Risk Analyst",
      "Lobbyist",
      "Consultancy"
    ]
  },
  {
    id: 42,
    name: "Film Making",
    subcategories: [
      "Script Writing",
      "Film Editing",
      "Cinematography",
      "Direction"
    ]
  },
  {
    id: 43,
    name: "Data Science & Artificial Intelligence",
    subcategories: []
  }
];
